// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var PrometheusPspAnalyticsController = function ($scope, PrometheusLog){
    $scope.dateFrom = moment().subtract(1, 'days').toISOString(true);
    $scope.dateTo = moment().toISOString(true);
    $scope.isLoading = true;

    $scope.PSP_ROLE = Object.freeze({
        'BlackLabel': 'BlackLabel',
        'CreditCard': 'CreditCard',
        'Debit': 'Debit',
        'OnAccount': 'OnAccount',
        'Betalingsservice': 'Betalingsservice',
        'iDEAL': 'iDEAL',
        'Autogiro': 'Autogiro',
        'Avtalegiro': 'Avtalegiro',
        'ApplePay': 'ApplePay',
        'VippsMobilePay': 'VippsMobilePay',
        'TWINT': 'TWINT',
    });

    $scope.PSP_TYPE = Object.freeze({
        'PayPal': 'PayPal',
        'FakeProvider': 'FakeProvider',
        'InvoicePayment': 'InvoicePayment',
        'PayOne': 'PayOne',
        'Unzer': 'Unzer',
        'Adyen': 'Adyen',
        'Stripe': 'Stripe',
        'StripeV2': 'StripeV2',
        'GoCardless': 'GoCardless',
        'Worldline': 'Worldline',
        'ThirdPartyIntegration': 'ThirdPartyIntegration',
        'MobilePay': 'MobilePay',
        'PayEx': 'PayEx',
        'FarPay': 'FarPay',
        'Mollie': 'Mollie',
        'AmazonPay': 'AmazonPay',
        'Reepay': 'Reepay',
        'Riverty': 'Riverty',
    });

    $scope.loadLogs = function () {
        PrometheusLog.pspLogs({
                dateFrom: $scope.dateFrom,
                dateTo: $scope.dateTo,
            },
            function (data) {
                $scope.pspData = data;
                
                $scope.isLoading = false;

            },
            function (data) {
                $scope.isLoading = false;
            });        
    }
    $scope.loadLogs();

    $scope.getAverageAndMaxByPspAndRole = function (psp, role) {
        var key = role + ":" + psp;
        if ($scope.pspData == null)
            return "-";
        var measure = $scope.pspData.find(item => item.MeasureName === key);
        return measure != null? measure.AverageTime + "ms" + " | " + measure.MaxTime + "ms" : "-";
    }
    
    $scope.clickApply = function(){
        $scope.isLoading = true;
        $scope.loadLogs();
    }    
}

PrometheusPspAnalyticsController.$inject = ['$scope', 'PrometheusLog'];
